import { render, staticRenderFns } from "./AddQualityTracing.vue?vue&type=template&id=1245bf76&scoped=true&"
import script from "./AddQualityTracing.vue?vue&type=script&lang=js&"
export * from "./AddQualityTracing.vue?vue&type=script&lang=js&"
import style0 from "./AddQualityTracing.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./AddQualityTracing.vue?vue&type=style&index=1&id=1245bf76&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1245bf76",
  null
  
)

export default component.exports